var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcChangeCharge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 42,
    viewBox: "0 0 64 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.9707 31.3642L47.982 31.3642L50.6514 28.6947C50.8721 28.4759 50.9962 28.1779 50.9962 27.867C50.9962 27.556 50.8721 27.2581 50.6514 27.0392C50.4331 26.8222 50.1375 26.7002 49.8297 26.7002C49.5216 26.7002 49.2263 26.8222 49.0077 27.0392L44.3448 31.7022C44.1241 31.921 44 32.2189 44 32.5299C44 32.8409 44.1241 33.1388 44.3448 33.3576L49.0077 38.0206C49.225 38.2357 49.518 38.3573 49.8237 38.3586C50.1336 38.3604 50.4316 38.2386 50.6514 38.0206C50.8721 37.8017 50.9962 37.5038 50.9962 37.1928C50.9962 36.8819 50.8721 36.5839 50.6514 36.3651L47.982 33.6956H61.9707C62.3871 33.6956 62.7719 33.4734 62.9803 33.1128C63.1885 32.7521 63.1885 32.3077 62.9803 31.947C62.7719 31.5864 62.3871 31.3642 61.9707 31.3642Z",
    fill: "#0C1C33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.852 32.0723V10.605H45.6016",
    stroke: "#0C1C33",
    strokeWidth: 2.66021,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47772 0.38623C6.39174 0.38623 5.49688 1.30292 5.49688 2.41538V3.76795H2.19568C1.1097 3.76795 0.214844 4.68463 0.214844 5.7971V26.0874C0.214844 27.1999 1.1097 28.1165 2.19568 28.1165H25.9643C27.0503 28.1165 27.9451 27.1999 27.9451 26.0874V5.7971C27.9451 4.68463 27.0503 3.76795 25.9643 3.76795H22.6631V2.41538C22.6631 1.30292 21.7683 0.38623 20.6823 0.38623C19.5963 0.38623 18.7014 1.30292 18.7014 2.41538V3.76795H9.45808V2.41538C9.45808 1.30292 8.56322 0.38623 7.47724 0.38623H7.47772ZM7.47772 1.7388C7.8549 1.7388 8.1379 2.02871 8.1379 2.41508V6.47308C8.1379 6.85946 7.85489 7.14936 7.47772 7.14936C7.10054 7.14936 6.81754 6.85945 6.81754 6.47308V2.41508C6.81754 2.02869 7.10054 1.7388 7.47772 1.7388ZM20.6825 1.7388C21.0597 1.7388 21.3427 2.02871 21.3427 2.41508V6.47308C21.3427 6.85946 21.0597 7.14936 20.6825 7.14936C20.3053 7.14936 20.0223 6.85945 20.0223 6.47308V2.41508C20.0223 2.02869 20.3053 1.7388 20.6825 1.7388ZM2.1958 5.12051H5.497V6.47308C5.497 7.58554 6.39186 8.50223 7.47783 8.50223C8.56381 8.50223 9.45867 7.58554 9.45867 6.47308V5.12051H18.702V6.47308C18.702 7.58554 19.5969 8.50223 20.6829 8.50223C21.7688 8.50223 22.6637 7.58554 22.6637 6.47308V5.12051H25.9649C26.3421 5.12051 26.6251 5.41042 26.6251 5.79679V9.85479H1.53597V5.79679C1.53597 5.41041 1.81898 5.12051 2.19615 5.12051H2.1958ZM1.53562 11.2076H26.6247V26.0871C26.6247 26.4735 26.3417 26.7634 25.9645 26.7634H2.19592C1.81873 26.7634 1.53574 26.4735 1.53574 26.0871V11.2076H1.53562Z",
    fill: "#0C1C33"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.2422,
    y: 20.9468,
    width: 29.5973,
    height: 20.0918,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.94402,
    y: 20.5627,
    width: 30.1264,
    height: 20.7705,
    rx: 1.58986,
    stroke: "#0C1C33",
    strokeWidth: 1.05991
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.373,
    y: 24.5171,
    width: 13.1735,
    height: 1.24782,
    transform: "rotate(90 16.373 24.5171)",
    fill: "#0C1C33"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5547,
    y: 24.5171,
    width: 13.1735,
    height: 1.12543,
    transform: "rotate(90 18.5547 24.5171)",
    fill: "#0C1C33"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.6719,
    y: 24.5171,
    width: 13.1735,
    height: 2.59347,
    transform: "rotate(90 23.6719 24.5171)",
    fill: "#0C1C33"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30.2227,
    y: 24.5171,
    width: 13.1735,
    height: 2.59347,
    transform: "rotate(90 30.2227 24.5171)",
    fill: "#0C1C33"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 32.7188,
    y: 24.5171,
    width: 13.1735,
    height: 1.17917,
    transform: "rotate(90 32.7188 24.5171)",
    fill: "#0C1C33"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 25.9062,
    y: 24.5171,
    width: 13.1735,
    height: 1.17917,
    transform: "rotate(90 25.9062 24.5171)",
    fill: "#0C1C33"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 34.9531,
    y: 24.5171,
    width: 13.1735,
    height: 1.17917,
    transform: "rotate(90 34.9531 24.5171)",
    fill: "#0C1C33"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChangeCharge);
export default __webpack_public_path__ + "static/media/ic-change-charge.affa3b225ac7f5df6efc8f12bea39061.svg";
export { ForwardRef as ReactComponent };